// extracted by mini-css-extract-plugin
export default {"wrapper":"MissingRolesAssignments_wrapper__iUJFJ","link":"MissingRolesAssignments_link__QM1kE"};